import { defineComponent } from 'vue';
import Image from '@/components/image/Image.vue';
export default defineComponent({
    name: 'QHomeQRCode',
    components: {
        Image,
    },
});
